import React from 'react';
import { ProductCard } from './ProductCard';
export function ProductsSection() {
  const sharedFeatures = ['4 tamaños de siliconas para un ajuste perfecto', 'Incluye caja de transporte', 'Ideal para recitales, ensayos o clubes', 'Con el filtro star reducen hasta -18db'];
  const products = [{
    title: 'BLACK ✪ CLASSIC',
    price: '$30.000',
    oldPrice: '$59.990',
    description: 'El clásico que nunca falla. Elegante, discreto, efectivo.',
    image: 'https://cdn.magicpatterns.com/uploads/nwCM1rjQ6GNknmnpNXgmWy/Black_1.webp',
    features: sharedFeatures,
    recommended: false,
    buyLink: 'https://www.quidarg.com.ar/productos/black-classic/'
  }, {
    title: 'DARK ✯ VIOLET',
    price: '$45.000',
    oldPrice: '$59.990',
    description: 'Protección premium con estilo. Para los que no pasan desapercibidos.',
    image: 'https://cdn.magicpatterns.com/uploads/u762FeMXJUdShkqahNAuQo/Dark_violet_1.webp',
    features: sharedFeatures,
    recommended: true,
    buyLink: 'https://www.quidarg.com.ar/productos/dark-violet-gold/'
  }, {
    title: 'SILVER ✮ METAL',
    price: '$45.000',
    oldPrice: '$59.990',
    description: 'Elegancia metalizada. Brilla tanto como vos en la pista.',
    image: 'https://cdn.magicpatterns.com/uploads/mx4ebcSb9KBA5XrBGQgYoe/Silver_1-.webp',
    features: sharedFeatures,
    recommended: false,
    buyLink: 'https://www.quidarg.com.ar/productos/silver-metal/'
  }];
  return <section id="compra" className="bg-gray-50 py-24" data-id="element-131">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="mb-16 text-center" data-id="element-133">
          <h2 className="mb-4 text-4xl font-bold text-gray-900 sm:text-5xl" data-id="element-134">
            Elegí tus filtros
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600" data-id="element-135">
            Invertí en tus oídos hoy. Agradecelo mañana.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-136">
          {products.map((product, index) => <ProductCard key={index} {...product} delay={index * 0.1} data-id="element-137" />)}
        </div>
      </div>
    </section>;
}